import { ssmRouterGuardService } from "@/shared/services/router-guard-service";
import Vue from "vue";
import Router from "vue-router";
import { RouterNames } from "./routernames";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/main",
    },
    {
      path: "*",
      redirect: "/main",
    },
    {
      path: "/login",
      name: RouterNames.Login,
      component: () => import("@/views/login/login-formulario.vue"),
    },{
      path: "/lostpwd",
      name: RouterNames.lostpwd,
      component: () => import("@/views/lostpwdforms/pswlost.vue"),
    },{
      path: "/confirm-new-password/:token",
      name: RouterNames.confirm_new_password,
      component: () => import("@/views/lostpwdforms/pwdlost-confirm.vue"),
    },{
      path: "/instalacion",
      name: RouterNames.instalacion,
      component: () => import("@/views/instalacion/instalacion.vue"),
    },
    {
      path: "/main",
      redirect: "/main/home",
      name: RouterNames.mainlayout,
      component: () => import("@/views/mainlayout/main-layout.vue"),
      beforeEnter: ssmRouterGuardService.beforeEnter,
      children: [
        {
          path: "home",
          name: RouterNames.Home,
          component: () => import("@/views/home/home.vue"),
        },
        {
          path: "usuarios",
          redirect: "/main/usuarios/lista",
          name: RouterNames.usuarios,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.usuarioslista,
              component: () =>
                import("@/views/usuarios/UsuariosLista.vue"),
              children: [],
            },
          ],
        },{
          path: "ayuntamientos",
          redirect: "/main/ayuntamientos/lista",
          name: RouterNames.ayuntamientos,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.ayuntamientoslista,
              component: () =>
                import("@/views/ayuntamientos/ayuntamientosList.vue"),
              children: [],
            },
          ],
        },{
          path: "agrupaciones",
          redirect: "/main/agrupaciones/lista",
          name: RouterNames.agrupaciones,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.agrupacioneslista,
              component: () =>
                import("@/views/agrupaciones_datos/config_agrupacion_datos.vue"),
              children: [],
            },
          ],
        },{
          path: "importaciones",
          name: RouterNames.importaciones,
          component: () =>
            import("@/views/importaciones/importacion_excel.vue"),
          children: [],
        },{
          path: "configuracion",
          redirect: "/main/configuracion/preguntas/lista",
          name: RouterNames.configuracion,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "preguntas",
              redirect: "/main/configuracion/preguntas/lista",
              name: RouterNames.preguntas,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.preguntaslista,
                  component: () =>
                    import("@/views/configuracion/encuestas/config_encuestas_lista.vue"),
                  children: [],
                },{
                  path: "formulario/:id",
                  name: RouterNames.preguntasformulario,
                  component: () =>
                    import("@/views/configuracion/encuestas/config_encuestas_formulario.vue"),
                  children: [],
                },
              ],
            },{
              path: "dashboards",
              redirect: "/main/configuracion/dashboards/lista",
              name: RouterNames.dashboards,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.dashboardslista,
                  component: () =>
                    import("@/views/configuracion/dashboards/config_dashboards_lista.vue"),
                  children: [],
                },{
                  path: "formulario/:id",
                  name: RouterNames.dashboardsformulario,
                  component: () =>
                    import("@/views/configuracion/dashboards/config_dashboards_formulario.vue"),
                  children: [],
                },
              ],
            },{
              path: "mapeador",
              redirect: "/main/configuracion/mapeador/lista",
              name: RouterNames.mapeador,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.mapeadorlista,
                  component: () =>
                    import("@/views/configuracion/mapeador/config_mapeador_lista.vue"),
                  children: [],
                },{
                  path: "formulario/:id",
                  name: RouterNames.mapeadorformulario,
                  component: () =>
                    import("@/views/configuracion/mapeador/config_mapeador_formulario.vue"),
                  children: [],
                }
              ],
            }
          ],
        },{
          path: "notificaciones",
          name: RouterNames.notificaciones,
          component: () => import("@/views/notificaciones/NotificacionesForm.vue"),
        },{
          path: "mi_perfil",
          name: RouterNames.mi_perfil,
          component: () => import("@/views/usuarios/MiPerfil.vue"),
        },
        {
          path: "cerrar_session",
          name: RouterNames.cerrar_session,
          component: () => import("@/views/cerrar_session.vue"),
          children: [],
        },
      ],
    },
  ],
});
